import { Dialog, DialogContent, DialogTitle, IconButton, Popover } from '@mui/material';
import { styled } from '@mui/material/styles';
import { extraColor } from './muiTheme';

export const ModalFooter = styled('div')<{ margin?: string }>(({ margin }) => ({
  gap: '15px',
  display: 'flex',
  justifyContent: 'flex-end',
  margin: margin || '32px 0 0',
}));

export const CloseModalIcon = styled(IconButton)(({ theme }) => ({
  margin: theme.spacing(1),
  padding: theme.spacing(1),

  '& svg': {
    width: 20,
    height: 20,
  },
}));

interface IStyledDialogProps {
  width?: string;
  minwidth?: string;
  maxwidth?: string;
  height?: string;
  minheight?: string;
}

export const StyledDialog = styled(Dialog, {
  shouldForwardProp: (prop) => !['width', 'minwidth', 'maxwidth', 'height', 'minheight'].includes(prop as string),
})<IStyledDialogProps>(({ width, minwidth, maxwidth, height, minheight }) => ({
  margin: 'auto',

  '& .MuiPaper-root': {
    maxWidth: '100%',
  },

  '& .MuiDialog-paper': {
    margin: 0,
    borderRadius: 0,

    ...(width && {
      width,
    }),

    ...(minwidth && {
      minWidth: minwidth,
    }),

    ...(maxwidth && {
      maxWidth: maxwidth,
    }),

    ...(height && {
      height,
      maxHeight: height,
    }),

    ...(minheight && {
      minHeight: minheight,
    }),

    '@media (max-width: 599px)': {
    '& svg': {
      width: '1.5rem !important',
      height: '1.5rem !important',
    },
  },
  },
}));

interface IStyledDialogTitleProps {
  $isReduced?: boolean;
  $isDraggable?: boolean;
}

export const StyledDialogTitle = styled(DialogTitle, {
  shouldForwardProp: (prop) => !['$isReduced', '$isDraggable'].includes(prop as string),
})<IStyledDialogTitleProps>(({ $isReduced, $isDraggable }) => ({
  justifyContent: 'space-between',
  padding: '0px 8px',
  fontSize: '18px',
  cursor: $isDraggable ? 'move' : 'auto',
  width: $isReduced ? '100%' : undefined,
  position: $isReduced ? 'absolute' : undefined,
  backgroundColor: extraColor.palette.blue.light,
  borderTop: `1px solid ${extraColor.palette.blue.main}`,
  borderBottom: `1px solid ${extraColor.palette.blue.main}`,
}));

export const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  padding: `0 ${theme.spacing(3)} ${theme.spacing(3)}`,
}));

export const ModalFormFooter = styled('div')({
  position: 'relative',
  display: 'flex',
  justifyContent: 'flex-end',
  paddingRight: '20px',
  paddingBottom: '20px',
});

export const PopoverStyle = styled(Popover)({
  '& .MuiPaper-root.MuiPopover-paper': {
    width: '595px',
    height: '835px',
    padding: '15px 24px 24px 24px',
    position: 'absolute',
  },
});

interface IPopOverHeaderWrapperProps {
  $isDraggable?: boolean;
}

export const PopOverHeaderWrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== '$isDraggable',
})<IPopOverHeaderWrapperProps>(({ $isDraggable }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  cursor: $isDraggable ? 'move' : 'auto',
}));
